module.exports = __webpack_public_path__ + "static/media/06.114.25160401.jpg";